import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ThePageTitle from '@/components/v2/PageTitle.vue';
import ProfitableProducts from '@/components/v2/ecommerce/ProfitableProducts';
import Avatar from '@/components/avatar/Index.vue';
import { DATA_TABLES_ITEMS } from '@/helpers/constants/app';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let ProfitableProductList = class ProfitableProductList extends Mixins(RouterParamsAppMixin, ViewportSizeMixin) {
    get dataTableItems() {
        return DATA_TABLES_ITEMS;
    }
    get headers() {
        return [
            {
                text: 'PRODUCT',
                value: 'name',
                align: 'left',
                sortable: false,
            },
            {
                sortable: false,
            },
            {
                text: 'PIECES SOLD',
                value: 'sold',
                align: 'center',
                sortable: false,
            },
            {
                text: 'Sales',
                value: 'sales',
                align: 'center',
                sortable: false,
            },
        ];
    }
};
ProfitableProductList = __decorate([
    Component({
        components: {
            ThePageTitle,
            ProfitableProducts,
            Avatar,
        },
    })
], ProfitableProductList);
export default ProfitableProductList;
